import React,{useState, useEffect} from 'react'
import { useHistory } from "react-router-dom"
import {Container,Input} from "reactstrap"
import "./growth.css"
import Header from "./Header"
import Footer from "./Footer"
import {Icon} from "@iconify/react"
import babyIcon from '@iconify-icons/fa-solid/baby';// npm install --save-dev @iconify/react @iconify-icons/openmoji

function Growth() {


    const [gesWeekAtBirth, setGesWeekAtBirth] = useState("");
    const [gesDayAtBirth, setGesDayatBirth] = useState("");
    const [birthWeight, setBirtWeight] = useState("");
    const [birthHeadC, setBirthHeadC] = useState("");
    const [postWeek, setPostWeek] = useState("");
    const [postDay, setPostDay] = useState("");
    const [weight, setWeight] = useState("");
    const [headCir, setHeadCir] = useState("");



    const [disabledTick, setDisabledTick] = useState(true)
    const [disabledText, setDisabledText] = useState(true)

    const [selectBoy, setSelectBoy] = useState(true)
    const [selectGirl, setSelectGirl] = useState(false)
    

    let history = useHistory();
    //default gender == boy

    

    const babygirl = () => {
        setSelectGirl(true)
        setSelectBoy(false)
          localStorage.setItem("gender","girl")
    }

    const babyboy = () => {
        setSelectBoy(true)
        setSelectGirl(false)
         localStorage.setItem("gender","boy")
    }

  
    const graph = () => {

      history.push("/graph");  
    
  }

    const handleGesWeek = (event) => {
        setGesWeekAtBirth(event.target.value);
        localStorage.setItem("Gestational age week", event.target.value);
      };

      const handleGesDay = (event) => {
        setGesDayatBirth(event.target.value);
        localStorage.setItem("Gestational age day", event.target.value);
      };

      const handleBirthWeight = (event) => {
        setBirtWeight(event.target.value);
        localStorage.setItem("Birth weight", event.target.value);
      };

      const handleBirthHeadC = (event) => {
        setBirthHeadC(event.target.value);
        localStorage.setItem("Birth head circumference", event.target.value);
      };

      const handlePostWeek = (event) => {
        if(!disabledTick){
        setPostWeek(event.target.value);
        localStorage.setItem("Postmenstrual age week", event.target.value);
        }
      };

      const handlePostDay = (event) => {
        if(!disabledTick){
        setPostDay(event.target.value);
        localStorage.setItem("Postmenstrual age day", event.target.value);
        }
      };

      const handleWeight = (event) => {
        if(!disabledTick){
        setWeight(event.target.value);
        localStorage.setItem("current weight", event.target.value);
        }
      };

      const handleHeadCir = (event) => {
        if(!disabledTick){
        setHeadCir(event.target.value);
        localStorage.setItem("Head circumference", event.target.value);
        }
      };

      const handleDisabledHD = (event) => {

      console.log(!disabledTick)

      if(!disabledTick){  //disable input
        setDisabledTick(true)
        setDisabledText(true)
        console.log("show NA @ input field")
      }

      if(disabledTick){
        setDisabledTick(false)
        setDisabledText(false)
        console.log("cancel NA @ input field")
      }

      }

    return (
        <div className="row">
        <div className="col-md-12">
        <div className = "growth__page1">
        <Header/>
        <div className = "growth__content">
        <div className = "header__topic">
          <h4>Growth Velocity</h4>
        </div>
          
        <div className = "growth__header">
         <p><strong>Please insert the necessary information into the blanks</strong></p>
        </div>
        <form onSubmit ={graph}>
        <div className = "gender__selection">
         <p>Gender</p>
        </div>
        <div className = "gender__icon"  >
        <Icon icon ={babyIcon} value = {selectGirl} className = { selectGirl ? "baby__girl1" : "baby__girl"} onClick = {babygirl}/>
        <Icon icon ={babyIcon} value = {selectBoy} className = { selectBoy ? "baby__boy1" : "baby__boy"} onClick = {babyboy}/> 
        </div>
        <div className = "at__birth">
        <div className = "underline__header">
            <p><strong>At birth</strong></p>
        </div>
        <p>Gestational Age <input step="any" required className = "ges__age" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0" size = "3" onChange = {handleGesWeek} value ={gesWeekAtBirth}/> weeks <input step="any" required className="ges__day" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0" size = "3" onChange = {handleGesDay} value ={gesDayAtBirth}/> days</p>
        <p>Birth weight <input step="any" required onChange = {handleBirthWeight} value ={birthWeight} className = "birth__weight" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0.000" size = "5"/> kg</p>
        <p>Birth head circumference <input step="any" required onChange = {handleBirthHeadC} value ={birthHeadC} className = "birth__headcir" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0.0" size = "5"/> cm</p>
        </div>
        <div className = "baby__discharged">
        <span>   
            <input
              type="checkbox"
              name="remember"
              onChange = {handleDisabledHD}
            /> Baby has been discharged
            <div className = "select__to__wish">Select if you wish to calculate z-score changed from birth to discharge</div>
        </span>
        </div>
        <div className = "at__hospital">
            <div className = "underline__header">
                <p><strong>At hospital discharge</strong></p>
                </div>
                <p>Postmentrual Age <input step="any" required disabled = {disabledTick} onChange = {handlePostWeek} value ={postWeek} className="post__age" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0" size ="3"/> weeks <input className = "post__day" step="any" required disabled = {disabledTick} onChange = {handlePostDay} value ={postDay} type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0" size ="3"/> days</p>
                <p>Weight <input step="any" required disabled = {disabledTick} onChange = {handleWeight} value ={weight} className = "weight__input" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0.000" size ="5"/> kg </p>
                <p>Head circumference <input step="any" required disabled = {disabledTick} onChange = {handleHeadCir} value ={headCir} className="head__cir" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0.0" size ="5"/> cm </p>
            <button className = "next__page" onSubmit = {graph}> Next page</button>
            </div>
            </form>
            </div>
            </div>
        </div>
        </div>
    )
}

export default Growth
